import axios from "axios";
import { buildApiUrl } from "./apiConfig";

//Get all the states

//--------------------FETCH ALL NOTES -----------------------------//

const getNotes = async (status = "active") => {
  const url = buildApiUrl(`note/data?status=${encodeURIComponent(status)}`);
  try {
    // await new Promise(resolve => setTimeout(resolve, 50000)); //

    const response = await axios.get(url);
    const data = response.data;
    // Transform the data into the desired format

    return data;
  } catch (error) {
    console.error(error);
    throw new Error("Some error occurred while fetching data.");
  }
};

//-------------------- CRETA A NEW NOTE  -----------------------------//

const createNewNote = async (noteData) => {
  const url = buildApiUrl("note/create");

  try {
    const response = await axios.post(url, noteData);
    if (response.status === 201) {
      // Note creation was successful
      return { success: true, data: response.data };
    } else {
      // Handle other possible response status codes (optional)
      return { success: false, message: "Failed to create the note." };
    }
  } catch (error) {
    console.error(error);
    throw new Error("Error creating the note.");
  }
};

// Archive keeps a note recoverable instead of permanently deleting it.
const archiveNote = async (noteId) => {
  const url = buildApiUrl(`note/soft-delete/${noteId}`);
  try {
    const response = await axios.put(url);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Some error occurred while archiving the note.");
  }
};

const restoreNote = async (noteId) => {
  const url = buildApiUrl(`note/restore/${noteId}`);
  try {
    return await axios.put(url);
  } catch (error) {
    console.error(error);
    throw new Error("Some error occurred while restoring the note.");
  }
};

const updateNote = async (noteId, updatedFields) => {
  const url = buildApiUrl(`note/update/${noteId}`);
  try {
    const response = await axios.put(url, updatedFields);
    return response; // Assuming the backend returns an object with `success` and `message` properties
  } catch (error) {
    console.error(error);
    throw new Error("Some error occurred while updating the note.");
  }
};

const getCurrentWeather = async (city) => {
  const url = buildApiUrl(`weather/current?city=${encodeURIComponent(city)}`);
  const response = await axios.get(url);
  return response.data;
};

export { getNotes, createNewNote, archiveNote, restoreNote, updateNote, getCurrentWeather };
